<template>
    <div>
        <div style="position: absolute;top: 0px;left: 200px;height: 80px;" :style="'width:'+ (screenWidth-200) + 'px'">
            <div class="title">现代数控加工工艺及装备教学辅助平台</div>
            
            <!-- <div style="height: 41px;position: relative;">
                <div style="width:190px;border: solid 1px #2044b1;height:31px;position: absolute;left: 60%;top: 60%;border-radius: 15.5px;overflow: hidden;display: flex;">
                    <input v-model="Select" @input="selectChange($event)" placeholder="请输入搜索内容" style="background-color: #fff;height: 29px;border: none;position: absolute;left: 0px;padding-left: 10px;" @keyup.enter="doSearch()"/>
                    <img src="../../assets/images/search.png" style="height:34px;width:35px;position: absolute;right: 0px;cursor: pointer;top: -2px;" alt="" @click="doSearch()">
                </div>
                
            </div> -->

            <el-tooltip effect="dark" content="消息通知" placement="bottom-start" style="position: absolute;top: 42%;left: 85%;" >
                <el-badge v-if="unReadNum > 0" :value="unReadNum" class="item">
                    <i class="el-icon-message-solid center_icon" @click="userNotice"></i>
                </el-badge>
                <i v-else class="el-icon-message-solid center_icon" @click="userNotice"></i>
            </el-tooltip>
            <el-dropdown style="position: absolute;top: 40%;left: 90%;">
                <span style="">
                    <i class="el-icon-setting" style="font-size: 15px;"></i>
                    <span>欢迎,{{ user_nickname }}</span>
                    <i class="el-icon-caret-bottom"></i>
                </span>
                
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="informationUpdate"><i class="el-icon-user"></i>修改信息</el-dropdown-item>
                <el-dropdown-item @click.native="passwordUpdate"><i class="el-icon-lock"></i>修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="logout"><i class="el-icon-delete-location"></i>退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                screenWidth: document.body.clientWidth,
                unReadNum: 0,
                Select: sessionStorage.getItem('selectName'),
                user_nickname: sessionStorage.getItem('user_nickname'),
            }
        },
        mounted() {
            this.getNoticeCount()
            this.Select = this.$parent.search ? this.$parent.search.name : ''
        },
        methods: { 
            selectChange(event) {
                sessionStorage.setItem('selectName', event.target.value)
            },
            doSearch() {
                if(this.$route.path != '/SelectResources') {
                    this.$router.push({
                        name: 'SelectResources'
                    })
                } else {
                    this.$parent.search.name = this.Select
                    this.$parent.getResourcesList();
                }
                
            },
            logout() {
                this.$axios.post(this.$global.basUrl + 'api/demo/public/logout', {}).then(res => {
                    var data = res.data
                    sessionStorage.clear()
                    this.$router.push({
                        path: '/'
                    })
                })
                
            },
            getNoticeCount() {
                this.$axios.post(this.$global.basUrl + 'api/demo/stu/userNoticeCount', {}).then(res => {
                    var data = res.data
                    if(data.code == 1) {
                        this.unReadNum = data.data
                    } else {
                        this.statusPd(data)
                    }
                })
            },
            passwordUpdate() {
                this.$router.push({
                    name: 'PasswordUpdate'
                })
            },
            informationUpdate() {
                this.$router.push({
                    name: 'InformationUpdate'
                })
            },
            userNotice() {
                this.$router.push({
                    name: 'userNotice'
                })
            }
        }
    }
</script>
<style scoped>
.el-menu > li {
        background-color: #0E80FF;
        color: #fff;
    }
    .el-menu-item.is-active { 
        background: linear-gradient(89deg, rgba(14,128,255,0.8) 0%, rgba(14,128,255,0.5) 100%) !important;
        opacity: 1 !important;
     }
     .home_logo{
        height: 47%;
        width: 80%;
        background: url('~@/assets/images/login_logo.png') center center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 30%;
        left: 10%;
     }
     .title{
        width: 40%;
        height: 30px;
        position: absolute;
        left: 5%;
        top: 30%;
        font-size: 20px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #222222;
        text-align: left;
     }
     
     .item {
        /* margin-top: -10px; */
        margin-right: 40px;
        width: 25px;
    }
</style>